import * as Sentry from '@sentry/browser';
import { Integrations as TracingIntegrations } from '@sentry/tracing';

const ERROR_SAMPLE_RATE_PRODUCTION = 0.05;
const ERROR_SAMPLE_RATE_DEV = 0.25;

const TRACE_SAMPLE_RATE = 0.005;

const errorSampleRate = App.isProduction ? ERROR_SAMPLE_RATE_PRODUCTION : ERROR_SAMPLE_RATE_DEV;

// Use TraceKit to detect and collect data on unhandled exceptions
if (!App.isProduction) {
   window.__wd_unique = Math.random();
   window.__js_errors = [];
   let onError = window.onerror;
   window.onerror = function (message, url, lineNo) {
      if (onError) {
         onError(message, url, lineNo);
      }
      window.__js_errors.push(message);
   };
}

let sentrySent = false;
const isShopifyLaunch =
   window.location.pathname.test(/(cart|store)/i) && new Date() < new Date('2021-08-04T12:00:00');
const forceSentry =
   isShopifyLaunch ||
   (App.canIForceSentryReporting && window.location.search.test(/(forceSentry)/));
const performanceOptions = App.sentryPerformance
   ? {
        integrations: [new TracingIntegrations.BrowserTracing()],
        tracesSampleRate: TRACE_SAMPLE_RATE,
     }
   : {};

Sentry.init({
   dsn: App.SENTRY_DSN,
   environment: App.isProduction ? 'production' : 'dev',
   sampleRate: forceSentry ? 1 : errorSampleRate,
   ...performanceOptions,
   // Limit to one error per page load please cause we've seen instances of
   // thousands of errors being sent by one user.
   beforeSend: function (event) {
      if (sentrySent) {
         return null;
      }

      sentrySent = true;
      return event;
   },
   normalizeDepth: 10,
});

Sentry.setTags(App.sentryTags);
